import React from "react";
import "./home.css";
import { FaUserShield, FaGlobe, FaCogs, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import ImageSlider from "../components/ImageSlider";

const Homepage = () => {
  return (
    <div className="homepage">

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          
          <h1>Empowering Businesses with Scalable IT Solutions</h1>
          <p>Trusted IT sales and services tailored to your industry needs.</p>
          <Link to="/service"><button className="cta-btn">Explore Solutions</button></Link>
        </div>
      </section>

      {/* Highlights */}
      <section className="highlights">
        <div className="highlight">
          <i className="icon">💡</i>
          <h3>24/7 Support</h3>
          <p>Always available to keep your systems running smoothly.</p>
        </div>
        <div className="highlight">
          <i className="icon">⚡</i>
          <h3>Scalable Infrastructure</h3>
          <p>Solutions that grow with your business.</p>
        </div>
        <div className="highlight">
          <i className="icon">🤝</i>
          <h3>Trusted by 500+ Clients</h3>
          <p>Building long-term partnerships across industries.</p>
        </div>
      </section>

      <ImageSlider />

      {/* Solutions Overview */}
    <section className="solutions">
  {/* Intro */}
  <div className="solutions-intro">
    <h2>Solutions That Drive Growth</h2>
    <p>
      Every business journey is unique. Our solutions guide you from sales enablement to secure digital transformation.
    </p>
  </div>

  {/* Timeline Layout */}
  <div className="solutions-timeline">
    <div className="solution-step left">
      <img src="/images/sales-solution.png" alt="Sales Solutions" />
      <div className="step-content">
        <h3>Sales Solutions</h3>
        <p>Hardware and software tailored for enterprise performance and scalability.</p>
        <Link to="/service"><button className="learn-btn">Learn More</button></Link>
      </div>
    </div>

    <div className="solution-step right">
      <img src="/images/service-solution.png" alt="Service Solutions" />
      <div className="step-content">
        <h3>Service Solutions</h3>
        <p>Consulting, maintenance, and managed IT services to keep systems running smoothly.</p>
        <Link to="/service"><button className="learn-btn">Learn More</button></Link>
      </div>
    </div>

    <div className="solution-step left">
      <img src="/images/cloud_solutions.png" alt="Cloud Solutions" />
      <div className="step-content">
        <h3>Cloud Solutions</h3>
        <p>Secure, scalable cloud infrastructure to support digital transformation and remote workforces.</p>
        <Link to="/service"><button className="learn-btn">Learn More</button></Link>
      </div>
    </div>

    <div className="solution-step right">
      <img src="/images/security.jpeg" alt="Security Solutions" />
      <div className="step-content">
        <h3>Security Solutions</h3>
        <p>Advanced cybersecurity strategies to protect your enterprise from evolving digital threats.</p>
        <Link to="/service"><button className="learn-btn">Learn More</button></Link>
      </div>
    </div>
  </div>

  {/* CTA Strip */}
  <div className="solutions-cta">
    <Link to="/service"><button className="solutions-cta-btn">Explore All Solutions</button></Link>
  </div>
</section>

      {/* Industries Served */}
    <section className="industries">
  <h2>Industries We Serve</h2>
  <div className="industry-grid">
    <div className="industry-card">
      <div className="icon">🏭</div>
      <h3>Manufacturing</h3>
      <p>Smart factory IT solutions that streamline production and supply chain efficiency.</p>
    </div>
    <div className="industry-card">
      <div className="icon">🏥</div>
      <h3>Healthcare</h3>
      <p>Secure patient data systems and telemedicine platforms for modern healthcare providers.</p>
    </div>
    <div className="industry-card">
      <div className="icon">💰</div>
      <h3>Finance</h3>
      <p>Robust fintech solutions ensuring compliance, security, and seamless digital transactions.</p>
    </div>
    <div className="industry-card">
      <div className="icon">🎓</div>
      <h3>Education</h3>
      <p>Cloud-based learning management systems and digital classrooms for institutions worldwide.</p>
    </div>
  </div>
</section>

      {/* Why Choose Us */}
    

<section className="advantages">
  <div className="advantages-container">
    {/* Left Column: Intro */}
    <div className="advantages-intro">
      <h2>Why Choose Us</h2>
      <p>
        We combine expertise, global presence, and tailored strategies to deliver IT solutions
        that businesses can rely on. Here’s what sets us apart:
      </p>
    </div>

    {/* Right Column: Advantage Cards */}
    <div className="advantage-list">
      <div className="advantage-card">
        <div className="icon"><FaUserShield /></div>
        <div>
          <h3>Certified Experts</h3>
          <p>Industry-recognized professionals ensuring trusted IT delivery.</p>
        </div>
      </div>
      <div className="advantage-card">
        <div className="icon"><FaGlobe /></div>
        <div>
          <h3>Global Reach</h3>
          <p>Serving clients worldwide with scalable infrastructure.</p>
        </div>
      </div>
      <div className="advantage-card">
        <div className="icon"><FaCogs /></div>
        <div>
          <h3>Tailored Solutions</h3>
          <p>Custom strategies aligned with your business goals.</p>
        </div>
      </div>
      <div className="advantage-card">
        <div className="icon"><FaCheckCircle /></div>
        <div>
          <h3>Proven Reliability</h3>
          <p>Decades of successful implementations and trusted partnerships.</p>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* CTA Banner */}
      <section className="cta-banner">
  <div className="cta-overlay">
    <div className="cta-content">
      <h2>Partner with Us for Reliable IT Solutions</h2>
      <p>
        Empower your business with scalable infrastructure, expert consulting, and proven reliability.
      </p>
      <div className="cta-actions">
        <Link to="/contact"><button className="cta-btn primary">Schedule a Consultation</button></Link>
        <Link to="/service"><button className="cta-btn secondary">Learn More</button></Link>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default Homepage;